module.exports = require("./../../_gen/starling/assets/AssetReference");